import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface PackingList {
  id: string
  packingNumber: string
  styleNumber: string
  poNumber: string
  status: string
  boxCount: number
  createdAt: string
}

interface PackingState {
  packingLists: PackingList[]
  loading: boolean
  total: number
  currentPage: number
  pageSize: number
}

const initialState: PackingState = {
  packingLists: [],
  loading: false,
  total: 0,
  currentPage: 1,
  pageSize: 20,
}

const packingSlice = createSlice({
  name: 'packing',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setPackingLists: (state, action: PayloadAction<{ packingLists: PackingList[]; total: number }>) => {
      state.packingLists = action.payload.packingLists
      state.total = action.payload.total
    },
    addPackingList: (state, action: PayloadAction<PackingList>) => {
      state.packingLists.unshift(action.payload)
      state.total += 1
    },
    updatePackingList: (state, action: PayloadAction<PackingList>) => {
      const index = state.packingLists.findIndex(list => list.id === action.payload.id)
      if (index !== -1) {
        state.packingLists[index] = action.payload
      }
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    },
  },
})

export const { setLoading, setPackingLists, addPackingList, updatePackingList, setCurrentPage } = packingSlice.actions
export default packingSlice.reducer